module.exports = __webpack_public_path__ + "img/epr-article-top-img_small@2x.78bce6cc.jpg";